export default __webpack_public_path__ + "static/media/StoreStep1.b718ccd5.svg";